import * as S from "./MainPostItem.style";
import { useNavigate } from "react-router-dom";
import { ReactComponent as IconComment } from "@/styles/assets/svg/icon_comment.svg";
import { ReactComponent as IconFavorite } from "@/styles/assets/svg/icon_favorite.svg";
import { timeStampToDate } from "@/lib/utils/timeStampToDate";
import { stripHtmlTags } from "@/lib/utils/stripHtmlTags";

interface MainPostItemProps {
  data: any;
  onClick?: any;
}

export const MainPostItem = ({ data, onClick }: MainPostItemProps) => {
  const navigate = useNavigate();

  return (
    <S.MainPostItem
      onClick={() => {
        if (data.category === "발달") {
          navigate(`/community/grow/${data.id}`);
        } else if (data.category === "육아") {
          navigate(`/community/info/tip/${data.id}`);
        } else {
          onClick && onClick();
        }
      }}
    >
      {/* 게시글 카테고리, 제목, 내용 */}
      <S.PostItemBox>
        <S.PostCategory
          $tagColor={
            data.category === "도서" ||
            data.category === "건강" ||
            data.topic === "도서"
              ? "Green"
              : data.category === "발달" ||
                data.category === "생활습관" ||
                data.topic === "발달&건강"
              ? "Orange"
              : data.category === "육아" ||
                data.category === "언어" ||
                data.topic === "육아정보"
              ? "Purple"
              : data.category === "여행" || data.category === "여행&맛집"
              ? "SkyBlue"
              : data.category === "성장" || data.category === "음식"
              ? "Pink"
              : data.category === "교육"
              ? "Yellow"
              : "Blue"
          }
        >
          {data.category ? data.category : data.topic ? data.topic : "기타"}
        </S.PostCategory>
        <S.PostTitBox>
          <S.PostTitle>{data.title}</S.PostTitle>
          <S.PostContent>
            {data.content && stripHtmlTags(data.content)}
          </S.PostContent>
        </S.PostTitBox>
      </S.PostItemBox>

      {/* 게시글 작성자, 게시시간, 조회수, 좋아요, 댓글 */}
      <S.PostInfoBox>
        {/* 유저 프로필 */}
        <S.UserInfo>
          <S.UserProfileImg>
            {data.profile_image_path && (
              <img
                src={`${process.env.REACT_APP_IMAGE_URL}/${data.profile_image_path}`}
                alt="유저 프로필 이미지"
              />
            )}
          </S.UserProfileImg>

          <S.Info>
            <span>{data.user_name}</span>
            {data.created_at && timeStampToDate(data.created_at)}
          </S.Info>
        </S.UserInfo>

        <S.PostReactionList>
          <S.PostReactionItem>
            <IconFavorite />
            <span>{data.like}</span>
          </S.PostReactionItem>

          <S.PostReactionItem>
            <IconComment />
            <span>{data.comment ? data.comment : "0"}</span>
          </S.PostReactionItem>
        </S.PostReactionList>
      </S.PostInfoBox>
    </S.MainPostItem>
  );
};
